export default __webpack_public_path__ + "static/media/meat.c538a6b5.png";